import axios from '@/lib/AxApi';

export default
{
  async selectBudget(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/selectBudget',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async selectDailySales(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/selectDailySales',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  
  async submitImport(params, cb)
  {
    try
    {
      var response = await axios.post('/StatisticsList/importBudgetFromCsv', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async submitActualImport(params, cb)
  {
    try
    {
      var response = await axios.post('/StatisticsList/importActualFromCsv', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async getWeeklyPerformanceSummary(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/getWeeklyPerformanceSummary',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async getWeeklyMinimumPlanner(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/getWeeklyMinimumPlanner',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async getQuarterlyMinimum(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/getQuarterlyMinimum',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async getQuartelyIndividiual(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/getQuartelyIndividiual',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async selectMonthlyBudget(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/selectMonthlyBudget',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async selectMonthlyBudgetTotal(params, cb)
  {
    try
    {
      var response = await axios.get('/StatisticsList/selectMonthlyBudgetTotal',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async setBudget(params, cb)
  {
    try
    {
      var response = await axios.post('/StatisticsList/setBudget', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async setActual(params, cb)
  {
    try
    {
      var response = await axios.post('/StatisticsList/setActual', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  }
}
